import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { dayByDayDataSelector } from "./selector";

export const TourViewDetailsHydrator = (WrappedComponent) => {
  class Comp extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state) => {
    const email = _.get(
      state.WebsiteMetadata,
      "metadata.contact_information.email"
    );
    const { details } = state.TourDetails;
    const { price_info } = state.TourPriceInfo;
    const {
      adults,
      children: childs,
      children_ages,
      date,
    } = state.PriceSearchForm;

    const dayByDayData = dayByDayDataSelector(state);

    return {
      email,
      details,
      price_info,
      adults,
      childs,
      children_ages,
      date,
      dayByDayData,
    };
  };

  return connect(mapStateToProps, null)(Comp);
};
